import {createFileRoute} from "@tanstack/react-router";
import {Redirect} from "@src/pages/redirect";
export const Route = createFileRoute("/_auth/redirect")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Redirect />;
}
